import React, { createContext, useContext, useState, useCallback } from 'react';

const AccessibilityContext = createContext(undefined);

export const AccessibilityProvider = ({ children }) => {
  const [isToolbarVisible, setIsToolbarVisible] = useState(false);

  const showToolbar = useCallback(() => setIsToolbarVisible(true), []);
  const hideToolbar = useCallback(() => setIsToolbarVisible(false), []);
  const toggleToolbar = useCallback(() => setIsToolbarVisible(prev => !prev), []);

  return (
    <AccessibilityContext.Provider value={{ isToolbarVisible, showToolbar, hideToolbar, toggleToolbar }}>
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useAccessibility = () => {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider');
  }
  return context;
};
